import { browserName, deviceDetect, deviceType, getUA, isDesktop, mobileModel, mobileVendor, osName } from "react-device-detect";
import { isNullOrEmpty } from "../Data/Util/util";
import { LOGGER, LogLevel } from "./Logger";

window.mobileAndTabletCheck = function() {
    let check = false;
    // @ts-ignore
    // eslint-disable-next-line
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};

/**
 * @returns TRUE if the device is running a mobile browser
 */
export function isMobile() {
    var isMobile = false;
    if (!isNullOrEmpty(navigator) && !isNullOrEmpty(navigator.userAgentData)){
        isMobile = navigator.userAgentData.mobile; //resolves true/false
    }
    if (!isMobile && !isNullOrEmpty(window)) {
        isMobile = window.mobileAndTabletCheck();
    }
    return isMobile;
}

export function isIOS() {
    if (isNullOrEmpty(window.navigator)) {
        return false;
    }

    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(window.navigator.platform)
    // iPad on iOS 13 detection
    || (window.navigator.userAgent.includes("Mac") && "ontouchend" in window.document);
}

// Safari 3.0+ "[object HTMLElementConstructor]" 
export var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

export function isMacOS() {
    if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
        return true; 
      } else {
        return false;
      }
    }

export function isEdge() {
    if (/Edge/.test(navigator.userAgent)) {
       return true;
    } else {
        return false;
    }   
}

const OS_LIST = [
    { name: 'Windows Phone', value: 'Windows Phone', version: 'OS', deviceId: 'WindowsPhone' },
    { name: 'Windows', value: 'Win', version: 'NT', deviceId: 'Windows' },
    { name: 'iPhone', value: 'iPhone', version: 'OS', deviceId: 'iPhone' },
    { name: 'iPad', value: 'iPad', version: 'OS', deviceId: 'iPad' },
    { name: 'Kindle', value: 'Silk', version: 'Silk', deviceId: 'Kindle' },
    { name: 'Android', value: 'Android', version: 'Android', deviceId: 'Android' },
    { name: 'PlayBook', value: 'PlayBook', version: 'OS', deviceId: 'PlayBook' },
    { name: 'BlackBerry', value: 'BlackBerry', version: '/', deviceId: 'BlackBerry' },
    { name: 'Macintosh', value: 'Mac', version: 'OS X', deviceId: 'Mac' },
    { name: 'Linux', value: 'Linux', version: 'rv', deviceId: 'Linux' },
    { name: 'Palm', value: 'Palm', version: 'PalmOS', deviceId: 'PalmOS' }
]

var BROWSER_LIST = [
    { name: 'Chrome', value: 'Chrome', version: 'Chrome', deviceId: 'Chrome' },
    { name: 'Firefox', value: 'Firefox', version: 'Firefox', deviceId: 'Firefox' },
    { name: 'Safari', value: 'Safari', version: 'Version', deviceId: 'Safari' },
    { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE', deviceId: 'InternetExplorer' },
    { name: 'Opera', value: 'Opera', version: 'Opera', deviceId: 'Opera' },
    { name: 'BlackBerry', value: 'CLDC', version: 'CLDC', deviceId: 'BlackBerry' },
    { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla', deviceId: 'Mozilla' }
]

const header = [
    navigator.platform,
    navigator.userAgent,
    navigator.appVersion,
    navigator.vendor,
    window.opera
];

function matchItem(string, data) {
    var i = 0,
        j = 0,
        regex,
        regexv,
        match,
        matches,
        version;
    
    for (i = 0; i < data.length; i += 1) {
        regex = new RegExp(data[i].value, 'i');
        match = regex.test(string);
        if (match) {
            regexv = new RegExp(data[i].version + '[- /:;]([._]+)', 'i');
            matches = string.match(regexv);
            version = '';
            if (matches) { if (matches[1]) { matches = matches[1]; } }
            if (matches) {
                matches = matches.split(/[._]+/);
                for (j = 0; j < matches.length; j += 1) {
                    if (j === 0) {
                        version += matches[j] + '.';
                    } else {
                        version += matches[j];
                    }
                }
            } else {
                version = '0';
            }
            return {
                name: data[i].name,
                version: parseFloat(version),
                deviceId: data[i].deviceId,
            };
        }
    }
    return { name: 'unknown', version: 0 };
}

/**
 * @returns the users device details
 */
export function getDeviceDetails() {
    var agent = header.join(' ');
    var os = matchItem(agent, OS_LIST);
    var browser = matchItem(agent, BROWSER_LIST);
    return {
        agent: agent,
        os: os,
        browser: browser
    };
}

/**
 * @returns the users device details to store in Firebase
 */
export function getDeviceDetailsFirebase() {

    const browserDetails = getDeviceDetails();

    var manufacturer, model, deviceId;
    var isMobile = false;
    try {
        isMobile = isMobile();
    } catch (ignore) {
    }

    var isDesktop = false;
    try {
        isDesktop = isDesktop();
    } catch (ignore) {
    }
    
    if (!isMobile || isDesktop) {
        manufacturer = browserDetails.os.name;
        model = browserDetails.os.value;
        deviceId = `${browserDetails.os.deviceId}-${browserDetails.browser.deviceId}`;
    } else {
        manufacturer = mobileVendor;
        model = mobileModel;
        if (!isNullOrEmpty(mobileModel)) {
            deviceId = `${mobileModel}-${browserDetails.browser.deviceId}`;
        }
    }
    
    if (isNullOrEmpty(model)) {
        model = browserDetails.os.deviceId;
    }

    if (isNullOrEmpty(deviceId) || deviceId === 'none' ) {
        deviceId = `${browserDetails.os.deviceId}-${browserDetails.browser.deviceId}`;
    }

    const os = osName;
    const token = null;

    const device = {
        deviceId: deviceId,
        os: os,
        manufacturer: manufacturer,
        model: model,
        token: token,
    };

    LOGGER.log(LogLevel.DEBUG,`deviceDetect, ${JSON.stringify(device)}`);

    return device;
}

